import {
  Box, Table, TableBody, useMediaQuery, useTheme
} from '@mui/material';
import React, { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LoanFormType } from 'views/orders/loans/types';

import { Row } from './components/row';

type Props = {
  loanForm: UseFormReturn<LoanFormType, object>,
  onSave: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
}

export const Increases: FC<Props> = ({ loanForm, onSave }) => {
  const { control } = loanForm;
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const rows = (
    <>
      <Row
        isMobile={isMobile}
        control={control}
        description={t('disclosure:loan-amount')}
        optionName="increase_loan_amount"
        options={
          [
            {
              title: t('disclosure:can-increase'),
              value: true
            },
            {
              title: t('disclosure:cannot-increase'),
              value: false
            }
          ]
        }
        conditionName="increase_loan_amount_text"
        loanForm={loanForm}
        onSave={onSave}
      />

      <Row
        isMobile={isMobile}
        control={control}
        description={t('disclosure:interest-rate')}
        optionName="increase_interest_rate"
        options={
          [
            {
              title: t('disclosure:can-increase'),
              value: true
            },
            {
              title: t('disclosure:cannot-increase'),
              value: false
            }
          ]
        }
        conditionName="increase_interest_rate_text"
        loanForm={loanForm}
        onSave={onSave}
      />

      <Row
        isMobile={isMobile}
        control={control}
        description={t('disclosure:monthly-principal-interest')}
        optionName="increase_monthly_principal"
        options={
          [
            {
              title: t('disclosure:can-increase'),
              value: true
            },
            {
              title: t('disclosure:cannot-increase'),
              value: false
            }
          ]
        }
        conditionName="increase_monthly_principal_text"
        loanForm={loanForm}
        onSave={onSave}
      />

      <Row
        isMobile={isMobile}
        control={control}
        description={t('disclosure:prepayment-penalty')}
        optionName="has_prepayment_penalty"
        options={
          [
            {
              title: t('common:yes'),
              value: true
            },
            {
              title: t('common:no'),
              value: false
            }
          ]
        }
        conditionName="has_prepayment_penalty_text"
        loanForm={loanForm}
        onSave={onSave}
      />

      <Row
        isMobile={isMobile}
        control={control}
        description={t('disclosure:balloon-payment')}
        optionName="has_balloon_payment"
        options={
          [
            {
              title: t('common:yes'),
              value: true
            },
            {
              title: t('common:no'),
              value: false
            }
          ]
        }
        conditionName="has_balloon_payment_text"
        loanForm={loanForm}
        onSave={onSave}
      />
    </>
  );

  if (isMobile) {
    return <Box>{rows}</Box>;
  }

  return (
    <Box style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
      <Table>
        <TableBody>
          {rows}
        </TableBody>
      </Table>
    </Box>
  );
};
